export default function AboutAppSection() {
  return (
    <>
      {/* #about */}
      <section id="about" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left: Visual */}
            <div className="flex-1 w-full max-w-sm lg:max-w-none">
              <div className="aspect-square rounded-2xl overflow-hidden border border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20modern%20streaming%20service%20brand%20illustration%20with%20play%20button%20icon%20centerpiece%2C%20soft%20coral%20and%20amber%20gradient%20accents%2C%20clean%20minimal%20design%2C%20floating%20media%20elements%20subtle%20in%20background%2C%20premium%20tech%20brand%20feel%2C%20no%20text%2C%20abstract%20geometric%20style&width=600&height=600&seq=about-visual-01&orientation=squarish"
                  alt="榴莲视频品牌介绍"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right: Content */}
            <div className="flex-1 w-full">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-information-line text-sm"></i>
                关于我们
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
                一站式高清视频聚合平台
              </h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                <p>
                  榴莲视频成立于 2020 年，专注为全球华人用户提供高品质免费在线视频服务。
                  平台聚合香蕉视频、红桃视频、91视频、蜜桃视频、樱花视频等多家主流品牌资源，
                  涵盖影视剧集、综艺娱乐、短视频创作、直播回放等多元内容形态。
                </p>
                <p>
                  我们采用分布式 CDN 加速与智能转码技术，确保在任何网络环境下都能实现流畅的高清播放体验。
                  每日内容团队精选更新超 300 部优质资源，所有视频均经过安全审核，
                  为用户打造绿色健康的观影环境。
                </p>
                <p>
                  截至目前，榴莲视频累计服务超过 1200 万用户，日均播放量突破 500 万次，
                  已成为中文互联网领域最受欢迎的视频聚合品牌之一。
                </p>
              </div>
              {/* Stats row */}
              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="text-center p-4 rounded-xl bg-background-100">
                  <div className="font-heading text-2xl text-primary-500">1200<span className="text-base">万+</span></div>
                  <div className="text-xs text-foreground-600 mt-1">累计用户</div>
                </div>
                <div className="text-center p-4 rounded-xl bg-background-100">
                  <div className="font-heading text-2xl text-accent-500">300<span className="text-base">部+</span></div>
                  <div className="text-xs text-foreground-600 mt-1">每日更新</div>
                </div>
                <div className="text-center p-4 rounded-xl bg-background-100">
                  <div className="font-heading text-2xl text-primary-500">99.9<span className="text-base">%</span></div>
                  <div className="text-xs text-foreground-600 mt-1">服务可用率</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #app */}
      <section id="app" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-10 lg:gap-16">
            {/* Right: Visual */}
            <div className="flex-1 w-full max-w-sm lg:max-w-none">
              <div className="aspect-[3/4] max-w-[280px] mx-auto rounded-2xl overflow-hidden border border-background-200/60 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20video%20streaming%20app%20interface%20with%20dark%20theme%2C%20video%20thumbnail%20grid%2C%20warm%20coral%20accent%20highlights%2C%20modern%20UI%20design%2C%20clean%20minimal%20layout%2C%20premium%20app%20aesthetic%2C%20no%20text%2C%20hand%20holding%20phone%20with%20soft%20background&width=600&height=800&seq=app-visual-01&orientation=portrait"
                  alt="榴莲视频APP界面"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Left: Content */}
            <div className="flex-1 w-full">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                <i className="ri-smartphone-line text-sm"></i>
                APP下载
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
                移动端专属APP · 随时随地想看就看
              </h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                <p>
                  榴莲视频移动端 APP 专为手机观影场景深度优化，支持 iOS 与 Android 双平台。
                  采用智能码率自适应技术，在 4G/5G/WiFi 环境下均可享受流畅的高清播放体验。
                </p>
                <p>
                  APP 独享离线缓存功能，可提前下载心仪影片，通勤途中、旅途间隙随时观看不耗流量。
                  个性化推荐引擎根据您的观看偏好，精准推送感兴趣的内容，发现更多精彩。
                </p>
              </div>
              {/* Download Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 mt-7">
                <a
                  href="#app"
                  className="flex items-center justify-center gap-3 px-6 py-3 bg-foreground-950 text-background-50 rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-xl"></i>
                  <div className="text-left">
                    <div className="text-[10px] leading-tight opacity-70">Download on the</div>
                    <div className="text-sm font-medium">App Store</div>
                  </div>
                </a>
                <a
                  href="#app"
                  className="flex items-center justify-center gap-3 px-6 py-3 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-google-play-fill text-xl"></i>
                  <div className="text-left">
                    <div className="text-[10px] leading-tight opacity-70">GET IT ON</div>
                    <div className="text-sm font-medium">Google Play</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}